import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-lock-line',
      title: t('service_1_title'),
      description: t('service_1_desc'),
      color: 'from-blue-500 to-blue-600',
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('service_2_title'),
      description: t('service_2_desc'),
      color: 'from-purple-500 to-purple-600',
    },
    {
      icon: 'ri-building-line',
      title: t('service_3_title'),
      description: t('service_3_desc'),
      color: 'from-teal-500 to-teal-600',
    },
    {
      icon: 'ri-search-eye-line',
      title: t('service_4_title'),
      description: t('service_4_desc'),
      color: 'from-orange-500 to-orange-600',
    },
  ];

  return (
    <section id="services" className="py-24 bg-neutral-bg">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-neutral-dark mb-4">
            {t('services_title')}
          </h2>
          <p className="text-xl text-neutral-text">
            {t('services_subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -8, transition: { duration: 0.3 } }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all cursor-pointer"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-neutral-dark mb-3">
                {service.title}
              </h3>
              <p className="text-neutral-text leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
